import Vue from 'vue'
import VueRouter from 'vue-router'
import Language from "@/views/Language"
import City from "@/views/City"
import Mode from "@/views/Mode"
import Friend from "@/views/Friend"
import Service from "@/views/Service"
import Director from "@/views/Director"
import Vision from "@/views/Vision"
import Login from "@/views/Login"
import SeriesStatus from "@/views/SeriesStatus"
import GameStatus from "@/views/GameStatus"
import Series from "@/views/Series"
import Platform from "@/views/Platform"
import Game from "@/views/Game"
import Tag from "@/views/Tag"


Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Vision',
      component: Vision
    },
    {
      path: '/vision',
      name: 'Vision',
      component: Vision
    },
    {
      path: '/series',
      name: 'Series',
      component: Series
    },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/city',
    name: 'City',
    component: City
  },
  {
    path: '/mode',
    name: 'Mode',
    component: Mode
  },
  {
    path: '/language',
    name: 'Language',
    component: Language
  },
  {
    path: '/friend',
    name: 'Friend',
    component: Friend
  },
    {
    path: '/tag',
    name: 'Tag',
    component: Tag
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  },
  {
    path: '/series_status',
    name: 'SeriesStatus',
    component: SeriesStatus
  },
  {
    path: '/game_status',
    name: 'GameStatus',
    component: GameStatus
  },
  {
    path: '/platform',
    name: 'Piattaforma',
    component: Platform
  },
  {
    path: '/game',
    name: 'Game',
    component: Game
  },
  {
    path: '/director',
    name: 'Director',
    component: Director
  }
 
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,_from, next) =>{
  const authRequired = to.path!="/login";
  let loggedIn = localStorage.getItem("user");
  if (authRequired && !loggedIn) {
    return next('/login')
  }
  next();
})

export default router
